import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Labels from "./pages/Labels/Labels";

export const customPages = [
	{ moduleId: "a34662c9-8ea7-4dff-9013-859cc2a56008", path: "list", content: <Labels /> },
] as CustomPage[];
